import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { OuiDateRange, OuiSelectOption } from 'omnium-ui/form-field';
import { SearchCommandeAutocompleteComponent } from 'projects/box-lib/src/lib/components/search-commande-autocomplete/search-commande-autocomplete.component';
import { SearchConsultantAutocompleteComponent } from 'projects/box-lib/src/lib/components/search-consultant-autocomplete/search-consultant-autocomplete.component';
import { AuthService } from 'projects/box-lib/src/lib/services/auth-service.service';
import { DashboardFiltersService } from 'projects/box-lib/src/lib/services/dashboard-filters.service';
import { OptionsService } from 'projects/box-lib/src/lib/services/options.service';
import { UserParametersService } from 'projects/box-lib/src/lib/services/user-parameters.service';
import { DashboardFilterEnum } from '../../../models/dashboardFilterEnum';
import {
  BackOfficeMember,
  Commande,
  Consultant,
  EnveloppeProduit,
  EnvoiEmailStatut,
  FondEvenementiel,
  Investisseur,
  NatureOperation,
  OperationFilterInput,
  Produit,
  Statut,
  StatutFilterInput,
  TypeSignaturePartenaire,
} from '../../../models/generated/graphql';
import {
  AbstractDashboardFilterComponent,
  FilterChips,
} from '../../dashboard-filters/abstract-dashboard-filter.component';
import { SearchInvestisseurAutocompleteComponent } from '../../search-investisseur-autocomplete/search-investisseur-autocomplete.component';
import { DatePipe } from '@angular/common';
import { SearchInvestisseurPersonnesPhysiquesComponent } from '../../search-investisseur-personnes-physiques/search-investisseur-personnes-physiques';
import { SearchInvestisseurPersonnesMoralesComponent } from '../../search-investisseur-personnes-morales/search-investisseur-personnes-morales';
import { SelectValue, toArrayOfValues, startOfDayUtc, endOfDayUtc } from '../../../utils/codeutils';

@Component({
    selector: 'lib-operation-dashboard-filters',
    templateUrl: './operation-dashboard-filters.component.html',
    styleUrls: ['./operation-dashboard-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OperationDashboardFiltersComponent extends AbstractDashboardFilterComponent<OperationFilterInput> {
  @ViewChild(SearchInvestisseurAutocompleteComponent)
  private investisseurSelector: SearchInvestisseurAutocompleteComponent;
  @ViewChild(SearchInvestisseurPersonnesPhysiquesComponent)
  private investisseurPersonnesPhysiquesSelector: SearchInvestisseurPersonnesPhysiquesComponent;
  @ViewChild(SearchInvestisseurPersonnesMoralesComponent)
  private investisseurPersonnesMoralesSelector: SearchInvestisseurPersonnesMoralesComponent;
  @ViewChild(SearchConsultantAutocompleteComponent)
  private consultantSelector: SearchConsultantAutocompleteComponent;
  @ViewChild(SearchCommandeAutocompleteComponent)
  private commandeSelector: SearchCommandeAutocompleteComponent;
  @Input({ required: true }) defaultQueryFilter: OperationFilterInput | undefined;
  @Input() preSelectedGestionnaireId: string | undefined;
  @Input() dashboardKey: string;
  @Output() onFilterInitialized = new EventEmitter<void>();

  fondsEvntOptions: OuiSelectOption<any>[] = [];
  statutOptions: OuiSelectOption<any>[] = [];
  produitOptions: OuiSelectOption<any>[] = [];
  enveloppeOptions: OuiSelectOption<any>[] = [];
  gestionnaireOptions: OuiSelectOption<any>[] = [];
  natureOperationOptions: OuiSelectOption<any>[] = [];
  tagOptions: OuiSelectOption<number>[] = [];
  signatureOptions: OuiSelectOption<TypeSignaturePartenaire>[] = [];
  errorEmailOptions: OuiSelectOption<boolean | undefined>[] = [];
  commandeAramisOptions: OuiSelectOption<boolean | undefined>[] = [];
  isInvestisseurPersonneMoraleOptions: OuiSelectOption<boolean>[] = [];
  modePaiementOptions: OuiSelectOption<string>[];
  demembrementOptions: OuiSelectOption<string>[] = [];

  statutControl = new FormControl<number[]>([]);
  enveloppeControl = new FormControl<number[]>([]);
  natureOperationControl = new FormControl<number[]>([]);
  produitControl = new FormControl<number[]>([]);
  montantControl = new FormControl();
  gestionnaireControl = new FormControl<number[]>([]);
  fondsEvntControl = new FormControl<number[]>([]);
  tagControl = new FormControl<(number | undefined)[]>([]);
  signatureControl = new FormControl<TypeSignaturePartenaire[]>([]);
  errorEmailControl = new FormControl<(boolean | undefined)[]>([]);
  commandeAramisControl = new FormControl<(boolean | undefined)[]>([]);
  isInvestisseurPersonneMoraleControl = new FormControl<boolean[]>([]);
  modePaiementControl = new FormControl<string[]>([]);
  demembrementControl = new FormControl<string[]>([]);

  updateDateRangeControl = new FormControl<OuiDateRange | null>(null);
  creationDateRangeControl = new FormControl<OuiDateRange | null>(null);

  datePipe = new DatePipe('fr-FR');

  selectedContrat: Commande | undefined;

  selectedConsultantId: number | null | undefined;
  selectedConsultant: Consultant | undefined;
  gestionnaires: BackOfficeMember[];

  isInvestFilterInitialized = false;

  isInitialized = false;

  isBackOffice = false;
  goToOperationId: number | null = null;
  goToOperationIdControl = new FormControl<number | null>(null);
  selectedContratId: number | null | undefined;

  // selectedInvestisseur: Investisseur | undefined;
  selectedInvestisseurAll?: Investisseur | undefined;
  selectedInvestisseurPhysique?: Investisseur | undefined;
  selectedInvestisseurMorale?: Investisseur | undefined;

  // selectedInvestisseurId: number | null | undefined;
  selectedInvestisseurAllId?: number | null | undefined;
  selectedInvestisseurPhysiqueId?: number | null | undefined;
  selectedInvestisseurMoraleId?: number | null | undefined;

  filterKey: string;
  isLoading: Boolean = true;

  constructor(
    optionsService: OptionsService,
    userParametersService: UserParametersService,
    protected dashboardFiltersService: DashboardFiltersService,
    protected authService: AuthService,
    protected cdRef: ChangeDetectorRef,
    private authServiceService: AuthService,
    private router: Router
  ) {
    super(optionsService, userParametersService);

    this.goToOperationIdControl.valueChanges.subscribe(id => {
      this.goToOperationId = id == null ? null : Number(id);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultQueryFilter']) {
      this.getStatuts();
      this.emitNewFilter();
    }
  }
  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.authService.userBackOfficeSubject.subscribe(user => {
      this.isBackOffice = this.authService.isBackOffice();
    });
  }
  override emitNewFilter(): void {
    if (this.defaultQueryFilter && this.isInitialized) {
      this.onFilterChanged.emit(this.buildNewFilter());
    }
  }
  goToOperation() {
    if (!Number.isNaN(this.goToOperationId)) {
      this.router.navigate(['backoffice', this.goToOperationId]);
    }
  }

  /**
   * Build a new filter object based on the chips selected in the filters.
   * If there is no defaultQueryFilter, it returns an empty object.
   * Otherwise, it creates a new filter object with the defaultQueryFilter and the chips selected for each filter.
   * The chips are grouped by filter and the filter name is used as the key.
   * The value of each filter is an array of filter objects, each one representing a chip.
   * The filter object is an 'and' filter, meaning that all the filter objects in the array must match.
   * @returns A new filter object.
   */
  override buildNewFilter(): OperationFilterInput {
    if (!this.defaultQueryFilter) return {};
    const requestFilter: OperationFilterInput = { and: [this.defaultQueryFilter] };
    for (const filter of this.filterStateMap.values()) {
      if (filter.chips.length > 0) {
        requestFilter.and?.push({ or: filter.chips.map(chip => chip.value.filter) });
      }
    }
    return requestFilter;
  }
  /**
   * Called when the component is initialized. It loads all the data needed for the filters that are active.
   * The data is loaded only if the filter is active.
   * @returns A promise that resolves when all the data is loaded.
   */
  override async getAllDataForFilters(): Promise<void> {
    if (this.isFilterActive(DashboardFilterEnum.FondEvnt)) {
      await this.getAllFondsEvenementiels();
    }

    if (this.isFilterActive(DashboardFilterEnum.Enveloppe) || this.isFilterActive(DashboardFilterEnum.Produit)) {
      await this.getProduits();
    }
    if (this.isFilterActive(DashboardFilterEnum.Gestionnaire)) {
      await this.getGestionnaires();
    }
    if (this.isFilterActive(DashboardFilterEnum.Nature)) {
      await this.getNatures();
    }
    if (this.isFilterActive(DashboardFilterEnum.Statut)) {
      await this.getStatuts();
    }
    if (this.isFilterActive(DashboardFilterEnum.Tag)) {
      await this.getOperationTags();
    }

    if (this.isFilterActive(DashboardFilterEnum.Signature)) {
      this.getAllSignatureOptions();
    }
    if (this.isFilterActive(DashboardFilterEnum.ErrorPartenaireEmail)) {
      this.getErrorEmailOptions();
    }
    if (this.isFilterActive(DashboardFilterEnum.CommandeAramis)) {
      this.getCommandeAramisOptions();
    }

    if (this.isFilterActive(DashboardFilterEnum.IsInvestisseurPersonneMorale)) {
      this.getIsInvestisseurPersonneMoraleOptions();
    }

    if (this.isFilterActive(DashboardFilterEnum.ModePaiement)) {
      this.getModePaiementOptions();
    }
    if (this.isFilterActive(DashboardFilterEnum.Demembrement)) {
      this.getDemembrementOptions();
    }
  }

  /**
   * This function is called when the component is initialized. It subscribes to all the form controls that are used
   * by the filters and creates a new filter when any of the controls values change.
   * Special case for investisseur and consultant (the control are in the autocomplete component)
   */
  override async subscribeToFilterChanges(): Promise<void> {
    this.initSelectFilter(
      this.enveloppeControl,
      this.enveloppeOptions,
      DashboardFilterEnum.Enveloppe,
      value => ({ operationConfig: { enveloppeId: { eq: value } } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.produitControl,
      this.produitOptions,
      DashboardFilterEnum.Produit,
      value => ({ produitId: { eq: value } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.natureOperationControl,
      this.natureOperationOptions,
      DashboardFilterEnum.Nature,
      value => ({ operationConfig: { natureOperationId: { eq: value } } }),
      this.dashboardKey
    );
    let gestionnaireId = undefined;
    if (this.preSelectedGestionnaireId) {
      gestionnaireId = this.getPreselectedGestionnaireId();
    }
    this.initSelectFilter(
      this.gestionnaireControl,
      this.gestionnaireOptions,
      DashboardFilterEnum.Gestionnaire,
      value => ({ gestionnaireId: { eq: value } }),
      this.dashboardKey,
      gestionnaireId
    );
    this.initSelectFilter(
      this.statutControl,
      this.statutOptions,
      DashboardFilterEnum.Statut,
      value => ({ statutId: { in: value } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.tagControl,
      this.tagOptions,
      DashboardFilterEnum.Tag,
      value => ({ tags: { some: { id: { eq: value } } } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.signatureControl,
      this.signatureOptions,
      DashboardFilterEnum.Signature,
      value => ({ typeSignaturePartenaire: { eq: value ?? null } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.fondsEvntControl,
      this.fondsEvntOptions,
      DashboardFilterEnum.FondEvnt,
      value => ({ fondEvenementiels: { some: { id: { in: value } } } }),
      this.dashboardKey
    );
    this.initSelectFilter(
      this.errorEmailControl,
      this.errorEmailOptions,
      DashboardFilterEnum.ErrorPartenaireEmail,
      value => {
        if (value) {
          return { emails: { some: { statutEnvoi: { eq: EnvoiEmailStatut.Error } } } };
        } else {
          return { emails: { all: { statutEnvoi: { neq: EnvoiEmailStatut.Error } } } };
        }
      },
      this.dashboardKey
    );

    this.initSelectFilter(
      this.commandeAramisControl,
      this.commandeAramisOptions,
      DashboardFilterEnum.CommandeAramis,
      value => {
        if (value) {
          return { contratId: { neq: null } };
        } else {
          return { contratId: { eq: null } };
        }
      },
      this.dashboardKey
    );

    this.initSelectFilter(
      this.modePaiementControl,
      this.modePaiementOptions,
      DashboardFilterEnum.ModePaiement,
      value => this.buildModePaiementAnyFilter(value),
      this.dashboardKey
    );

    this.initSelectFilter(
      this.demembrementControl,
      this.demembrementOptions,
      DashboardFilterEnum.Demembrement,
      value => ({
        donneesSpecifiques: {
          or: [{ contains: `"demembrement":"${value}"` }, { contains: `"demembrement": "${value}"` }],
        },
      }),
      this.dashboardKey
    );

    this.initSelectFilter(
      this.isInvestisseurPersonneMoraleControl,
      this.isInvestisseurPersonneMoraleOptions,
      DashboardFilterEnum.IsInvestisseurPersonneMorale,
      value => {
        if (value) {
          return { isInvestisseurPersonneMorale: { eq: true } };
        } else {
          return { isInvestisseurPersonneMorale: { eq: false } };
        }
      },
      this.dashboardKey
    );

    // specific init for montant as it is not a select filter
    this.initFilter(
      this.montantControl,
      DashboardFilterEnum.Montant,
      value => this.createMontantChips(value?.minimum, value?.maximum),
      chips => {
        if (!chips || chips.length === 0) {
          return undefined;
        }
        return chips[0].value.dataValue;
      },
      this.dashboardKey
    );

    this.initFilter(
      this.creationDateRangeControl,
      DashboardFilterEnum.CreationDateRange,
      value => this.createCreationDateRangeChips(value),
      chips => {
        if (!chips || chips.length === 0) {
          return undefined;
        }
        return chips[0].value.dataValue;
      },
      this.dashboardKey
    );

    this.initFilter(
      this.updateDateRangeControl,
      DashboardFilterEnum.UpdateDateRange,
      value => this.createUpdateDateRangeChips(value),
      chips => {
        if (!chips || chips.length === 0) {
          return undefined;
        }
        return chips[0].value.dataValue;
      },
      this.dashboardKey
    );
    // specific init for contrat selector
    this.filterStateMap.set(DashboardFilterEnum.NumeroContrat, {
      chips: [],
      filterType: DashboardFilterEnum.NumeroContrat,
      key: this.dashboardKey,
    });

    this.selectedContratId = await this.userParametersService.getUserParam(
      this.dashboardKey,
      DashboardFilterEnum.NumeroContrat.toString()
    );

    if (this.selectedContratId != null) {
      this.selectedContrat = await this.dashboardFiltersService.getCommandeById(this.selectedContratId);
    }

    if (this.selectedContrat) {
      this.udpateContratFilter(this.selectedContrat);
    }

    // specific init for consultant selector
    this.filterStateMap.set(DashboardFilterEnum.Consultant, {
      chips: [],
      filterType: DashboardFilterEnum.Consultant,
      key: this.dashboardKey,
    });

    this.selectedConsultantId = await this.userParametersService.getUserParam(
      this.dashboardKey,
      DashboardFilterEnum.Consultant.toString()
    );

    if (this.selectedConsultantId != null) {
      this.selectedConsultant = await this.dashboardFiltersService.getConsultantById(this.selectedConsultantId);
    }

    if (this.selectedConsultant) {
      this.udpateConsultantFilter(this.selectedConsultant);
    }

    // specific init for investisseur selector
    this.selectedInvestisseurAllId = await this.userParametersService.getUserParam(
      this.dashboardKey,
      DashboardFilterEnum.Investisseur.toString()
    );

    if (this.selectedInvestisseurAllId != null) {
      this.selectedInvestisseurAll = await this.dashboardFiltersService.getInvestisseurById(
        this.selectedInvestisseurAllId
      );
    }

    if (this.selectedInvestisseurAll != null)
      this.updateInvestisseurFilterCore(DashboardFilterEnum.Investisseur, this.selectedInvestisseurAll, 'Investisseur');

    // specific init for investisseur selector with personnes physiques
    this.selectedInvestisseurPhysiqueId = await this.userParametersService.getUserParam(
      this.dashboardKey,
      DashboardFilterEnum.InvestisseurPersonnePhysique.toString()
    );

    if (this.toValidId(this.selectedInvestisseurPhysiqueId)) {
      this.selectedInvestisseurPhysique = await this.dashboardFiltersService.getInvestisseurById(
        this.toValidId(this.selectedInvestisseurPhysiqueId)!
      );
    }

    if (this.selectedInvestisseurPhysique != null)
      this.updateInvestisseurFilterCore(
        DashboardFilterEnum.InvestisseurPersonnePhysique,
        this.selectedInvestisseurPhysique,
        'Investisseur (PP)'
      );

    // specific init for investisseur selector with personnes morales
    this.selectedInvestisseurMoraleId = await this.userParametersService.getUserParam(
      this.dashboardKey,
      DashboardFilterEnum.InvestisseurPersonneMorale.toString()
    );
    if (this.toValidId(this.selectedInvestisseurMoraleId)) {
      this.selectedInvestisseurMorale = await this.dashboardFiltersService.getInvestisseurById(
        this.toValidId(this.selectedInvestisseurMoraleId)!
      );
    }

    if (this.selectedInvestisseurMorale != null)
      this.updateInvestisseurFilterCore(
        DashboardFilterEnum.InvestisseurPersonneMorale,
        this.selectedInvestisseurMorale,
        'Investisseur (PM)'
      );
    this.isInitialized = true;
    this.isLoading = false;
    // Boolean used to ensure that filters are properly initialized
    // and to prevent results from longer, non-filtered requests from overwriting the filtered results.
    this.onFilterInitialized.emit();

    // Ensure a new filter is emitted only after all filters are initialized
    setTimeout(() => {
      this.emitNewFilter();
    });
  }

  private toValidId(raw: unknown): number | undefined {
    const value = Array.isArray(raw) ? raw[0] : raw;
    const id = Number(value);

    return Number.isFinite(id) && id > 0 ? id : undefined;
  }

  private buildModePaiementAnyFilter(input: SelectValue<string>) {
    const modes = toArrayOfValues(input);

    if (modes.length === 0) return {};

    return {
      donneesSpecifiques: {
        and: [
          {
            or: [{ contains: `"modePaiement":[` }, { contains: `"modePaiement": [` }],
          },
          {
            or: modes.map(mode => ({ contains: `"${mode}"` })),
          },
        ],
      },
    };
  }

  private createCreationDateRangeChips(
    range: OuiDateRange | null
  ): FilterChips<{ dateCreation: { gte?: Date; lte?: Date } }>[] {
    if (!range?.start && !range?.end) {
      return [];
    }

    const start = range.start ? startOfDayUtc(range.start) : undefined;
    const end = range?.end ? endOfDayUtc(range.end) : undefined;

    const labelStart = start ? this.datePipe.transform(start, 'dd-MM-yyyy') : null;
    const labelEnd = end ? this.datePipe.transform(end, 'dd-MM-yyyy') : null;

    const label =
      labelStart && labelEnd
        ? `Date : du ${labelStart} au ${labelEnd}`
        : labelStart
          ? `Date : depuis le ${labelStart}`
          : `Date : jusqu'au ${labelEnd}`;

    const chip: FilterChips<{ dateCreation: { gte?: Date; lte?: Date } }> = {
      value: {
        type: DashboardFilterEnum.CreationDateRange,
        filter: { dateCreation: { gte: start, lte: end } },
        dataValue: range,
      },
      label,
    };

    return [chip];
  }
  private createUpdateDateRangeChips(
    range: OuiDateRange | null
  ): FilterChips<{ dateModification: { gte?: Date; lte?: Date } }>[] {
    if (!range?.start && !range?.end) {
      return [];
    }

    const start = range.start ? startOfDayUtc(range.start) : undefined;
    const end = range.end ? endOfDayUtc(range.end) : undefined;

    const labelStart = start ? this.datePipe.transform(start, 'dd-MM-yyyy') : null;
    const labelEnd = end ? this.datePipe.transform(end, 'dd-MM-yyyy') : null;

    const label =
      labelStart && labelEnd
        ? `Mise à jour : du ${labelStart} au ${labelEnd}`
        : labelStart
          ? `Mise à jour : depuis le ${labelStart}`
          : `Mise à jour : jusqu'au ${labelEnd}`;

    return [
      {
        value: {
          type: DashboardFilterEnum.UpdateDateRange,
          filter: { dateModification: { gte: start, lte: end } },
          dataValue: range,
        },
        label,
      },
    ];
  }

  override resetControlValues(): void {
    this.produitControl?.setValue([]);
    this.enveloppeControl?.setValue([]);
    this.natureOperationControl?.setValue([]);
    this.gestionnaireControl?.setValue([]);
    this.montantControl?.setValue({ minimum: undefined, maximum: undefined });
    this.statutControl?.setValue([]);
    this.consultantSelector?.setControlValue(null);

    this.investisseurSelector?.setControlValue(null);
    this.investisseurPersonnesMoralesSelector.investisseurSelector?.setControlValue(null);
    this.investisseurPersonnesPhysiquesSelector.investisseurSelector?.setControlValue(null);
    this.userParametersService.removeUserParam(this.dashboardKey, DashboardFilterEnum.Investisseur.toString());
    this.userParametersService.removeUserParam(
      this.dashboardKey,
      DashboardFilterEnum.InvestisseurPersonnePhysique.toString()
    );
    this.userParametersService.removeUserParam(
      this.dashboardKey,
      DashboardFilterEnum.InvestisseurPersonneMorale.toString()
    );

    this.commandeSelector?.setControlValue(null);
    this.tagControl?.setValue([]);
    this.signatureControl?.setValue([]);
    this.errorEmailControl?.setValue([]);
    this.commandeAramisControl?.setValue([]);
    this.isInvestisseurPersonneMoraleControl?.setValue([]);
    this.demembrementControl?.setValue([]);
    this.modePaiementControl?.setValue([]);

    this.creationDateRangeControl?.setValue({ start: undefined, end: undefined });
    this.updateDateRangeControl?.setValue({ start: undefined, end: undefined });
  }

  checkPreselectedGestionnaire(gestionnaires: BackOfficeMember[]) {
    if (this.preSelectedGestionnaireId) {
      const gestionnaire = gestionnaires.find(g => g.tokenId == this.preSelectedGestionnaireId);
      if (gestionnaire) {
        this.gestionnaireControl.setValue([gestionnaire.id]);
      }
    }
  }

  getPreselectedGestionnaireId() {
    if (this.preSelectedGestionnaireId) {
      const gestionnaire = this.gestionnaires.find(g => g.tokenId == this.preSelectedGestionnaireId);
      if (gestionnaire) {
        return [gestionnaire.id];
      }
    }
    return [];
  }

  async getProduits() {
    const produits = await this.dashboardFiltersService.getProduits();
    this.setProduitAndEnveloppeOptions(produits);
  }

  async getNatures() {
    const natureOperations = await this.dashboardFiltersService.getNatures();
    this.setNatureOperationOptions(natureOperations);
  }

  async getGestionnaires() {
    this.gestionnaires = await this.dashboardFiltersService.getGestionnaires();
    this.setGestionnaireOptions(this.gestionnaires);
  }
  async getStatuts() {
    if (!this.defaultQueryFilter) return;
    const where: StatutFilterInput = this.transformToStatutFilter(this.defaultQueryFilter);
    const statuts = (await this.dashboardFiltersService.getStatuts(where)) ?? [];
    this.authService.isBackOffice()
      ? this.setStatutOptions(statuts, 'backOfficeLibelle')
      : this.setStatutOptions(statuts, 'consultantLibelle');
  }

  // FIXME : this call use paginated query in the service: this is temporary solution and not a future-proof solution. Need input from UIUX team
  async getAllFondsEvenementiels() {
    const allFondsEvenementiels = await this.dashboardFiltersService.getAllFondsEvenementiels();
    this.setFondsEvenementielOptions(allFondsEvenementiels);
  }

  async getOperationTags() {
    this.tagOptions = await this.optionsService.getOperationTagOptions();
  }

  getAllSignatureOptions() {
    this.signatureOptions = this.optionsService.getTypeSignaturePartenaireOptions();
  }

  getErrorEmailOptions() {
    this.errorEmailOptions = this.optionsService.getTypeErrorEmailFilterOptions();
  }

  getCommandeAramisOptions() {
    this.commandeAramisOptions = this.optionsService.getCommandeAramisOptions();
  }

  getModePaiementOptions() {
    this.modePaiementOptions = this.optionsService.getModePaiementOptions();
  }

  getDemembrementOptions() {
    this.demembrementOptions = this.optionsService.getDemembrementSelectOptions();
  }

  getIsInvestisseurPersonneMoraleOptions() {
    this.isInvestisseurPersonneMoraleOptions = this.optionsService.getIsInvestisseurPersonneMoraleOptions();
  }
  private transformToStatutFilter(operationFilter: OperationFilterInput): StatutFilterInput {
    const statutFilter: StatutFilterInput = {};
    if (!operationFilter) return statutFilter;

    if (operationFilter.statutId) {
      statutFilter.id = { ...(operationFilter.id || operationFilter.statutId) };
    }

    if (operationFilter.and) {
      statutFilter.and = operationFilter.and.map(filter => this.transformToStatutFilter(filter));
    }

    if (operationFilter.or) {
      statutFilter.or = operationFilter.or.map(filter => this.transformToStatutFilter(filter));
    }

    return statutFilter;
  }

  private setStatutOptions(statuts: Statut[], propertyName: 'consultantLibelle' | 'backOfficeLibelle') {
    const groupedStatus: { [libelle: string]: number[] } = statuts.reduce(
      (accumulate: { [libelle: string]: number[] }, statut) => {
        const { id } = statut;
        const libelle = statut[propertyName];
        if (libelle) {
          if (!accumulate[libelle]) {
            accumulate[libelle] = [];
          }
          accumulate[libelle].push(id);
        }
        return accumulate;
      },
      {}
    );

    const options = Object.entries(groupedStatus).map(([libelle, value]) => ({ label: libelle, value }));
    this.statutOptions = options.sort((a, b) => a.label.localeCompare(b.label));
  }

  setProduitAndEnveloppeOptions(produits: Produit[]) {
    this.produitOptions = this.createOptions(
      produits,
      produit => produit.nomTechniqueProduitBox ?? produit.nom ?? 'Produit sans nom',
      produit => produit.id
    );
    this.enveloppeOptions = this.createEnveloppeOptions(produits);
    this.toggleControlState(this.produitControl, this.produitOptions);
    this.toggleControlState(this.enveloppeControl, this.enveloppeOptions);
  }

  setNatureOperationOptions(natures: NatureOperation[]) {
    this.natureOperationOptions = this.createOptions(
      natures,
      nature => nature.libelle ?? 'Nature sans nom',
      nature => nature.id
    );
    this.toggleControlState(this.natureOperationControl, this.natureOperationOptions);
  }

  setGestionnaireOptions(gestionnaires: BackOfficeMember[]) {
    this.gestionnaireOptions = this.createOptions(
      gestionnaires,
      gestionnaire => gestionnaire.displayName ?? 'Gestionnaire sans nom',
      gestionnaire => gestionnaire.id
    );
    this.toggleControlState(this.gestionnaireControl, this.gestionnaireOptions);
  }

  setFondsEvenementielOptions(fondsEvenementiels: FondEvenementiel[]) {
    this.fondsEvntOptions = this.createOptions(
      fondsEvenementiels,
      fondsEvenementiel => fondsEvenementiel.libelle ?? 'Fonds sans nom',
      fondsEvenementiel => fondsEvenementiel.id
    );
    this.toggleControlState(this.fondsEvntControl, this.fondsEvntOptions);
  }
  createEnveloppeOptions(produits: Produit[]): OuiSelectOption<any>[] {
    const enveloppes: EnveloppeProduit[] = [];
    produits.forEach(prod => {
      if (prod.enveloppeNavigation) {
        enveloppes.find(env => env?.code === prod.enveloppeNavigation?.code) ??
          enveloppes.push(prod.enveloppeNavigation);
      }
    });
    return enveloppes
      .map(env => ({ label: env?.libelle ?? 'Enveloppe sans nom', value: env?.code }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  createMontantChips(minimum: number | null, maximum: number | null): FilterChips<OperationFilterInput>[] {
    if (minimum || maximum) {
      const filter = this.getMontantFilter(minimum, maximum);
      if (filter) {
        return [
          {
            label: this.getMontantChipsLabel(minimum, maximum),
            value: { type: DashboardFilterEnum.Montant, filter, dataValue: { minimum, maximum } },
          },
        ];
      }
    }
    return [];
  }

  getMontantFilter(minimum: number | null, maximum: number | null): OperationFilterInput | null {
    const filter: OperationFilterInput = { and: [] };
    if (minimum) filter.and?.push({ montant: { gte: minimum } });
    if (maximum) filter.and?.push({ montant: { lte: maximum } });
    return minimum === null && maximum === null ? null : filter;
  }

  private getMontantChipsLabel(minimum: number | null, maximum: number | null): string {
    if (minimum && maximum) return `${minimum}€ - ${maximum}€`;
    if (minimum) return `>= ${minimum}€`;
    if (maximum) return `<= ${maximum}€`;
    return '';
  }

  onInvestisseurAllSelected(inv?: Investisseur) {
    this.selectedInvestisseurAll = inv;
    this.selectedInvestisseurAllId = inv?.id;

    if (!inv) {
      this.userParametersService.removeUserParam(this.dashboardKey, DashboardFilterEnum.Investisseur.toString());
    } else {
      this.userParametersService.saveUserParam(this.dashboardKey, DashboardFilterEnum.Investisseur.toString(), inv.id);
    }

    this.updateInvestisseurFilterCore(DashboardFilterEnum.Investisseur, inv, 'Investisseur');
    this.emitNewFilter();
  }

  onInvestisseurPhysiqueSelected(inv?: Investisseur) {
    this.selectedInvestisseurPhysique = inv;
    this.selectedInvestisseurPhysiqueId = inv?.id;

    if (!inv) {
      this.userParametersService.removeUserParam(
        this.dashboardKey,
        DashboardFilterEnum.InvestisseurPersonnePhysique.toString()
      );
    } else {
      this.userParametersService.saveUserParam(
        this.dashboardKey,
        DashboardFilterEnum.InvestisseurPersonnePhysique.toString(),
        inv.id
      );
    }

    this.updateInvestisseurFilterCore(DashboardFilterEnum.InvestisseurPersonnePhysique, inv, 'Investisseur (PP)');
    this.emitNewFilter();
  }

  onInvestisseurMoraleSelected(inv?: Investisseur) {
    this.selectedInvestisseurMorale = inv;
    this.selectedInvestisseurMoraleId = inv?.id;

    if (!inv) {
      this.userParametersService.removeUserParam(
        this.dashboardKey,
        DashboardFilterEnum.InvestisseurPersonneMorale.toString()
      );
    } else {
      this.userParametersService.saveUserParam(
        this.dashboardKey,
        DashboardFilterEnum.InvestisseurPersonneMorale.toString(),
        inv.id
      );
    }

    this.updateInvestisseurFilterCore(DashboardFilterEnum.InvestisseurPersonneMorale, inv, 'Investisseur (PM)');
    this.emitNewFilter();
  }

  private updateInvestisseurFilterCore(
    filterType: DashboardFilterEnum,
    investisseur: Investisseur | undefined,
    labelPrefix: string
  ) {
    let chips: FilterChips<OperationFilterInput>[] = [];

    if (investisseur?.id) {
      const displayName = investisseur.investisseurEntite?.displayName ?? '-';
      chips = [
        {
          label: `${labelPrefix} : ${displayName}`,
          value: {
            type: filterType,
            filter: {
              or: [{ investisseurId: { eq: investisseur.id } }, { coInvestisseurId: { eq: investisseur.id } }],
            },
            dataValue: investisseur.id,
          },
        },
      ];
    }

    this.filterStateMap.set(filterType, {
      chips,
      filterType,
      key: this.dashboardKey,
    });

    this.emitNewFilter();
  }

  onConsultantSelected(consultant: Consultant | undefined) {
    this.selectedConsultant = consultant;
    this.selectedConsultantId = consultant?.id;

    if (!consultant) {
      this.userParametersService.removeUserParam(this.dashboardKey, DashboardFilterEnum.Consultant.toString());
    } else {
      this.userParametersService.saveUserParam(
        this.dashboardKey,
        DashboardFilterEnum.Consultant.toString(),
        consultant.id
      );
    }

    this.udpateConsultantFilter(consultant);
    this.emitNewFilter();
  }

  private udpateConsultantFilter(consultant: Consultant | undefined) {
    let chips: FilterChips<OperationFilterInput>[] = [];
    if (consultant?.id) {
      const displayName = consultant?.personnePhysique[0]?.nom + ' ' + consultant?.personnePhysique[0]?.prenom;
      chips = [
        {
          label: `Consultant : ${displayName}`,
          value: {
            type: DashboardFilterEnum.Consultant,
            filter: {
              and: [{ consultantId: { eq: consultant?.id } }],
            },
            dataValue: consultant?.id,
          },
        },
      ];
    }
    this.filterStateMap.set(DashboardFilterEnum.Consultant, {
      chips,
      filterType: DashboardFilterEnum.Consultant,
      key: this.dashboardKey,
    });
  }

  onContratSelected(commande: Commande | undefined) {
    if (commande?.id) {
      this.userParametersService.saveUserParam(
        this.dashboardKey,
        DashboardFilterEnum.NumeroContrat.toString(),
        commande.id
      );
    } else {
      this.userParametersService.removeUserParam(this.dashboardKey, DashboardFilterEnum.NumeroContrat.toString());
    }

    this.udpateContratFilter(commande);
    this.emitNewFilter();
  }

  private udpateContratFilter(commande: Commande | undefined) {
    let chips: FilterChips<OperationFilterInput>[] = [];
    if (commande?.id) {
      const produit = commande.produit?.nomTechniqueProduitBox ?? commande.produit?.nom ?? 'produit non défini';
      const numero = commande.numeroContrat;
      const investisseur =
        commande?.investisseurCommande[0]?.investisseur?.investisseurEntite?.displayName ?? 'investisseur inconnu';
      const label = `${numero} - ${produit} - ${investisseur}`;
      chips = [
        {
          label,
          value: {
            type: DashboardFilterEnum.NumeroContrat,
            filter: { contratId: { eq: commande.id } },
            dataValue: commande.id,
          },
        },
      ];
    }
    this.filterStateMap.set(DashboardFilterEnum.NumeroContrat, {
      chips,
      filterType: DashboardFilterEnum.NumeroContrat,
      key: this.dashboardKey,
    });
  }

  /**
   * Removes a specified filter chip and updates corresponding form control values.
   *
   * This function first removes the given filter chip from the filter state map.
   * - It then updates the form control values based on the type of the filter chip if the form control exists.
   * - If there s no form control (as in the case of Investisseur or Consultant) the associated selector's value is reset to null,
   * and the chips list in the filter state map is cleared.
   *
   * This method also triggers the emission of a new filter event after updating
   * the control values.
   *
   * @param chip - The filter chip to be removed, which contains a filter value and type.
   */

  override onRemove(chip: FilterChips<OperationFilterInput>) {
    this.removeChipFromFilter(chip);
    // Update form control values based on the type of the filter chip
    switch (chip.value.type) {
      case DashboardFilterEnum.Produit:
        this.updateControlValue(this.produitControl, chip.value.filter.produitId?.eq);
        break;
      case DashboardFilterEnum.Enveloppe:
        this.updateControlValue(this.enveloppeControl, chip.value.filter.operationConfig?.enveloppeId?.eq);
        break;
      case DashboardFilterEnum.Nature:
        this.updateControlValue(this.natureOperationControl, chip.value.filter.operationConfig?.natureOperationId?.eq);
        break;
      case DashboardFilterEnum.Gestionnaire:
        this.updateControlValue(this.gestionnaireControl, chip.value.filter.gestionnaireId?.eq);
        break;
      case DashboardFilterEnum.Investisseur:
        this.investisseurSelector.setControlValue(null);
        const filter = this.filterStateMap.get(DashboardFilterEnum.Investisseur);
        if (filter) {
          filter.chips = [];
          this.userParametersService.removeUserParam(this.dashboardKey, DashboardFilterEnum.Investisseur.toString());
        }
        break;

      case DashboardFilterEnum.InvestisseurPersonneMorale:
        this.investisseurPersonnesMoralesSelector.investisseurControl.setValue(null);
        const investisseurPersonneMoraleFilter = this.filterStateMap.get(
          DashboardFilterEnum.InvestisseurPersonneMorale
        );
        if (investisseurPersonneMoraleFilter) {
          investisseurPersonneMoraleFilter.chips = [];
          this.userParametersService.removeUserParam(
            this.dashboardKey,
            DashboardFilterEnum.InvestisseurPersonneMorale.toString()
          );
        }
        break;
      case DashboardFilterEnum.InvestisseurPersonnePhysique:
        this.investisseurPersonnesPhysiquesSelector.investisseurControl.setValue(null);
        const investisseurPersonnePhysiqueFilter = this.filterStateMap.get(
          DashboardFilterEnum.InvestisseurPersonnePhysique
        );
        if (investisseurPersonnePhysiqueFilter) {
          investisseurPersonnePhysiqueFilter.chips = [];
          this.userParametersService.removeUserParam(
            this.dashboardKey,
            DashboardFilterEnum.InvestisseurPersonnePhysique.toString()
          );
        }
        break;
      case DashboardFilterEnum.Consultant:
        this.consultantSelector.setControlValue(null);
        const consultantFilter = this.filterStateMap.get(DashboardFilterEnum.Consultant);
        if (consultantFilter) {
          consultantFilter.chips = [];
        }
        break;
      case DashboardFilterEnum.NumeroContrat:
        this.commandeSelector.setControlValue(null);
        const commandeFilter = this.filterStateMap.get(DashboardFilterEnum.NumeroContrat);
        if (commandeFilter) {
          commandeFilter.chips = [];
        }
        break;
      case DashboardFilterEnum.Montant:
        this.montantControl.setValue({ minimum: undefined, maximum: undefined });
        break;
      case DashboardFilterEnum.Statut:
        this.updateControlValue(this.statutControl, chip.value.filter.statutId?.in);
        break;
      case DashboardFilterEnum.Tag:
        this.updateControlValue(this.tagControl, chip.value.filter.tags?.some?.id?.eq);
        break;
      case DashboardFilterEnum.Signature:
        this.updateControlValue(this.signatureControl, chip.value.filter.typeSignaturePartenaire?.eq);
        break;
      case DashboardFilterEnum.FondEvnt:
        this.updateControlValue(this.fondsEvntControl, chip.value.filter.fondEvenementiels?.some?.id?.in);
        break;
      case DashboardFilterEnum.ErrorPartenaireEmail:
        this.updateControlValue(this.errorEmailControl, chip.value.dataValue);
        break;
      case DashboardFilterEnum.CommandeAramis:
        this.updateControlValue(this.commandeAramisControl, chip.value.dataValue);
        break;
      case DashboardFilterEnum.IsInvestisseurPersonneMorale:
        this.updateControlValue(this.isInvestisseurPersonneMoraleControl, chip.value.dataValue);
        break;
      case DashboardFilterEnum.CreationDateRange:
        this.creationDateRangeControl?.setValue({ start: undefined, end: undefined });
        break;
      case DashboardFilterEnum.UpdateDateRange:
        this.updateDateRangeControl?.setValue({ start: undefined, end: undefined });
        break;
      case DashboardFilterEnum.ModePaiement:
        this.updateControlValue(this.modePaiementControl, chip.value.dataValue);
        break;
      case DashboardFilterEnum.Demembrement:
        this.updateControlValue(this.demembrementControl, chip.value.dataValue);
        break;
      default:
        break;
    }

    this.emitNewFilter();
  }
}
